/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  priceChart root reducer
 */

import { safeFilterActions } from '@zcode/utils'
import { priceChartReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export { whitelist }
export const priceChart = safeFilterActions(priceChartReducer, whitelist)
